import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HoldingImage } from "@cinch-nx/shared-ui";
import cx from "classnames";
import Image from "next/image";
import styles from "./product-image.module.css";
export var ProductImage = function(param) {
    var isAvailable = param.isAvailable, image = param.image, alt = param.alt, children = param.children;
    var hasImage = image && image.length > 0;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.imgContainer,
        children: [
            hasImage ? /*#__PURE__*/ _jsx(Image, {
                className: cx(styles.img, _define_property({}, styles.unavailable, !isAvailable)),
                src: image,
                alt: alt,
                layout: "fill"
            }) : /*#__PURE__*/ _jsx(HoldingImage, {
                text: "Image Unavailable",
                isAvailable: isAvailable
            }),
            children
        ]
    });
};
